<template>
  <div class="flex flex-col justify-between items-center py-10">
    <img :src="require(`@/assets/svg/no-table-data.svg`)" class="h-32 w-32" />
    <p class="text-xl font-bold uppercase text-gray-dark py-2">No Data Found</p>
    <p class="font-semibold text-md text-gray-light">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "EmptyTable",
  props: {
    description: {
      type: String,
      default: "Try adjusting the filters to see more.",
    },
  },
  data() {
    return {};
  },
};
</script>